module.exports = __webpack_public_path__ + "media/images/whatsapp-1-b9ca2fe48302197b10138da7a4bc5ea4.png";